<template>
    <div class="message">
        <div class="message-header">
            <div class="message-avatar">
                <div class="avatar-img" @click="actionSheet">
                    <img :src="userInfo.wechatInfo.headimgurl" />
                    <span :class="'avatar-tip tip-status-'+workStatus"></span>
                </div>
                <mt-actionsheet
                        :actions="actions"
                        v-model="sheetVisible">
                </mt-actionsheet>
                <div class="message-user-info" @click="enterStationEdit">
                    <div class="user-info-name">{{ userInfo.name }}</div>
                    <div class="user-info-station">{{ stationName }}</div>
                </div>
            </div>
            <div class="message-search">
                <div class="search-content">
                    <input class="search" placeholder="可搜索消息" v-model="search" />
                    <i class="mintui mintui-search"></i>
                </div>
            </div>
        </div>

        <div class="message-banner" v-if="!isSearch">
            <mt-swipe :auto="4000">
                <mt-swipe-item v-for="item in bannerList" :key="item.id">
                    <img :src="imgUrl+'uploads/'+item.thumb" />
                </mt-swipe-item>
            </mt-swipe>
        </div>

        <div class="message-body">

            <router-link to="/self" v-if="!isSearch" >
                <div class="self-order-button" >
                    <a>自助下单</a>
                </div>
            </router-link>


            <div class="message-service" v-if="!isSearch">
                <div class="message-title-header no-padding-top">
                    <div class="message-title">个体服务</div>
                    <router-link to="/my/service"><span>记录</span></router-link>
                </div>
                <div class="service-list">
                    <div class="service-card" @click="enterService('入户')">
                        <img class="service-img" src="../../static/care.png" />
                        <div class="service-title">入户</div>
                    </div>

                    <div class="service-card" @click="enterService('电访')">
                        <img class="service-img" src="../../static/phone.png" />
                        <div class="service-title">电访</div>
                    </div>
                    <div class="service-card" @click="enterService('医疗')">
                        <img class="service-img" src="../../static/tingzhenqi.png" />
                        <div class="service-title">医疗</div>
                    </div>
                    <div class="service-card" @click="enterService('家政')">
                        <img class="service-img" src="../../static/other.png" />
                        <div class="service-title">家政</div>
                    </div>
                </div>

                <div class="message-title-header">
                    <div class="message-title">群体服务</div>
                    <router-link to="/my/service"><span>记录</span></router-link>
                </div>
                <div class="service-list">
                    <div class="service-card" @click="enterService('便民活动')">
                        <img class="service-img" src="../../static/bianmin.png" />
                        <div class="service-title">便民活动</div>
                    </div>

                    <div class="service-card" @click="enterService('基础教育')">
                        <img class="service-img" src="../../static/jiaoyu.png" />
                        <div class="service-title">基础教育</div>
                    </div>
                    <div class="service-card" @click="enterService('康乐活动')">
                        <img class="service-img" src="../../static/kangle.png" />
                        <div class="service-title">康乐活动</div>
                    </div>
                    <div class="service-card" @click="enterService('志愿活动')">
                        <img class="service-img" src="../../static/zhiyuan.png" />
                        <div class="service-title">志愿活动</div>
                    </div>
                </div>

                <div class="message-title-header">
                    <div class="message-title">专业服务</div>
                    <router-link to="/my/service"><span>记录</span></router-link>
                </div>
                <div class="service-list">
                    <div class="service-card" @click="enterService('个案工作')">
                        <img class="service-img" src="../../static/gean.png" />
                        <div class="service-title">个案工作</div>
                    </div>

                    <div class="service-card" @click="enterService('小组工作')">
                        <img class="service-img" src="../../static/xiaozu.png" />
                        <div class="service-title">小组工作</div>
                    </div>

                    <div class="service-card append-card">
                    </div>

                    <div class="service-card append-card">
                    </div>

                </div>
            </div>

            <div class="message-list" v-if="!isSearch">
                <div class="message-title-header">
                    <div class="message-title">消息列表</div>
                    <router-link to="/messageList"><span>更多</span></router-link>
                </div>
            </div>
            <div class="message-list-body">
                <div class=" message-block message-top"  v-for="item in noteList"  v-if="!isSearch">
                    <span class="message-top-text">置顶</span>
                    <div class="message-block-body">
                        <div class="message-block-title">
                            通知公告
                        </div>
                        <div class="message-block-info">
                            {{ item.content }}
                        </div>
                    </div>
                </div>

                <ul class="mui-table-view message-list" v-infinite-scroll="loadMore" infinite-scroll-disabled="moreLoading" infinite-scroll-distance="0" infinite-scroll-immediate-check="false">
                    <!--li数据遍历循环部分-->
                    <li class="mui-table-view-cell message-block" v-for="item in messageList" @click="enterMessage(item.id)">
                        <span :class="'message-top-text '+importance_class[item.importance]+' has_read_label_'+item.has_read">{{ importance_name[item.importance] }}</span>
                        <div class="message-block-body">
                            <div :class="'message-block-title has_read_'+item.has_read">
                                {{ item.title }}
                            <!--    <span class="message-type">{{ type_text[item.type]}}</span>-->
                            </div>
                            <div class="message-block-info">
                                {{ item.content }}
                            </div>
                            <div class="message-time">
                                {{ item.created_at }}
                            </div>
                        </div>
                    </li>
                    <!--底部判断是加载图标还是提示“全部加载”-->
                    <li class="more_loading" v-show="queryLoading">
                        <mt-spinner class="spinner" type="fading-circle"  color="#ffcb01;" :size="25"></mt-spinner>
                    </li>
                    <li class="more_loading" v-show="!queryLoading">
                        <span class="loaded">已全部加载</span>
                    </li>
                </ul>
            </div>
        </div>
        <footer-bar :messageCount="messageCount"></footer-bar>
    </div>
</template>
<script>
    import GlOBAL from "@/api/global"
    import Footer from '../components/footer.vue'
    import { Actionsheet } from 'mint-ui'

    export default{
        components: {
            'footer-bar': Footer
        },

        data(){
            return {
                userInfo:JSON.parse(window.localStorage.getItem('UserInfo')),
                search:'',
                isSearch:false,

                index:'',
                bannerList:[],
                imgUrl:GlOBAL.imgUrl,

                stationName:'',
                workStatus:0,
                sheetVisible:false,

                actions:[
                    {
                        name: '在岗',
                        method : this.changeStatus0
                    },
                    {
                        name: '外出',
                        method : this.changeStatus1
                    },
                    {
                        name:'会议',
                        method :  this.changeStatus2
                    },
                    {
                        name:'休假',
                        method :  this.changeStatus3
                    }
                ],

                noteList:[],

                //初始化无限加载相关参数
                messageList:[],
                queryLoading: true,
                pageNum:1,

                importance_name:['一般','重要','紧急'],
                importance_class:['message_normal','message_important','message_agent'],
                type_text:{'SEND':'人工消息','SYSTEM':'系统消息'},

                messageCount:0
            }
        },

        methods:{

            actionSheet: function(){
                this.sheetVisible = true;
            },

            enterStationEdit:function(){
                if(this.userInfo.role_level===2){
                    this.$router.push('/my/station');
                }
            },

            changeStatus0: function(){ this.changeStatus(0); },
            changeStatus1: function(){ this.changeStatus(1); },
            changeStatus2: function(){ this.changeStatus(2); },
            changeStatus3: function(){ this.changeStatus(3); },

            changeStatus: function(status){

                if(this.sheetVisible===true){
                    this.$indicator.open('加载中');
                    let that = this;

                    this.$axios.post("/my/status", {openid:this.userInfo.openid,status:status})
                        .then(data => {

                            this.$indicator.close();

                            if (data.data.code === 'OK') {
                                this.$toast('状态切换成功!');
                                that.workStatus = status;
                            } else {
                                this.$toast(data.data.message);
                            }
                        });
                }

            },


            enterService(type){
                let single_type_array = ["入户","电访","医疗","家政","个案工作"];

                if(single_type_array.indexOf(type)<0){
                    this.$router.push('/service2?type='+type);
                }else{
                    this.$router.push('/service/'+type);
                }
            },

            enterMessage(id){
                this.$router.push('/message/'+id);
            },

            //无限加载函数
            loadMore() {

                if(!this.queryLoading){
                    return;
                }

                this.pageNum++;
                this.$axios.post("/message/list", {openid:this.userInfo.openid,page:this.pageNum,search:this.search}).then(data => {
                    if(data.data.code === 'OK'){

                        this.messageList = this.messageList.concat(data.data.data.data);
                        if(data.data.data.data.length===0){
                            this.queryLoading = false;
                        }
                    }

                });
            }
        },

        created(){
            this.$indicator.open('加载中');

            this.$axios.post("/message/list", {openid:this.userInfo.openid,page:1})
                .then(data => {

                    if (data.data.code === 'OK') {
                        this.messageList = data.data.data.data;
                        if(this.messageList.length<10){
                            this.queryLoading = false;
                        }
                    } else {
                        this.$toast(data.data.message);
                    }
                });

            this.$axios.get("/initial?openid="+this.userInfo.openid)
                .then(data => {

                    this.$indicator.close();

                    if (data.data.code === 'OK') {
                        this.bannerList = data.data.data.banner;
                        this.noteList = data.data.data.notes;
                        this.stationName = data.data.data.station;
                        this.workStatus = data.data.data.work_status;
                    } else {
                        this.$toast(data.data.message);
                    }
                });

            this.$axios.get("/message/count?openid="+this.userInfo.openid).then(data => {
                if(data.data.code === 'OK'){
                    this.messageCount = data.data.data;
                }

            });
        },

        watch:{
            search:{
                handler(){

                    this.messageList = [];

                    if(this.search!==''){
                        this.isSearch = true;
                    }else{
                        this.isSearch = false;
                    }

                    this.pageNum = 1;
                    this.$axios.post("/message/list", {openid:this.userInfo.openid,page:1,search:this.search})
                        .then(data => {
                            if (data.data.code === 'OK') {
                                this.messageList = data.data.data.data;
                                if(this.messageList.length<10){
                                    this.queryLoading = false;
                                }
                            } else {
                                this.$toast(data.data.message);
                            }
                        });
                    if(this.search===''){
                        this.queryLoading = true;
                    }
                }
            }
        },

    }
</script>
<style scoped>

    .message-header{
        display:flex;
        justify-content: space-between;
        background:#fff;
        padding: 25px 20px 20px 20px;
    }
    .message-avatar{
        width:35%;
        display:flex;
        justify-content: flex-start;
        height:30px;
    }

    .avatar-img{
        width:40%;
        position:relative;
    }

    .avatar-tip{
        position:absolute;/*根据父元素绝对定位*/
        width:8px;
        height:8px;
        top:0;/*在父元素的内部的顶部*/
        right:35px;/*在父元素的内部的右边*/
        -webkit-border-radius: 50%;
        -moz-border-radius: 50%;
        border-radius:50%;
    }

    .tip-status-0{
        background:#00a65a;
    }

    .tip-status-1{
        background:rgba(250,60,0,1);
    }

    .tip-status-2{
        background:#f39c12;
    }

    .tip-status-3{
        background:#d2d6de
    }


    .message-user-info{
        font-size: 12px;
        padding-left:5px;
    }

    .user-info-station{
        color: #888;
        font-size:10px;
    }

    .message-avatar img{
        width:100%;
        border-radius:50%;
        margin-top: -5px;
    }

    .message-search{
        width:65%;
        padding-left:3%;
    }

    .message .search-content{
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        background: #fff;
        margin: 0 auto;
        border-radius: 15px;
        height: 30px;
        line-height: 30px;
        border: 1px solid #dedede;
    }

    .message .search-content .search{
        font-size: small;
        width: 100%;
        border-radius: 20px;
        border: none;
        padding:0 20px;
    }

    .message .search-content .search:focus{
        outline: none;
    }

    .message .search-content i{
        padding-right:10px;
    }

    .message-banner{
        height:180px;
    }

    .message-banner img{
        width:100%;
    }

    .message-body{
        padding:20px;
    }


    .info-avatar img{
        width:64px;
        height:64px;
        border-radius:64px;
    }

    .append-card{
        background:none!important;
    }

    .info-avatar{
        padding-left:20px;
    }

    .info-detail{
        padding-left:20px;
    }

    .info-detail p{
        margin:.2em 0;
        font-size:14px;
    }

    .service-list{
        display:flex;
    }

    .service-img{
        width:65%;
      /*  box-shadow: 0 8px 17px 0 rgba(0, 0, 0, 0.2), 0 6px 5px 0 rgba(0, 0, 0, 0.15);*/
        border-radius:10px;
    }

    .service-card{
        padding-top:5px;
        text-align:center;
     /*   border: 1px solid #dedede;*/
        margin-right:5px;
        border-radius:5px;
        background:#fff;
        flex: 1;
    }

    .service-card:last-child{
        margin-right:0;
    }

    .service-title{
        text-align:center;
        font-size:14px;
        padding-bottom:10px;
    }

    .message-title-header{
        display:flex;
        justify-content: space-between;
        padding:15px 0;
    }

    .no-padding-top{
        padding-top:0;
    }

    .message-title-header a{
        text-decoration:none;
    }

    .message-title-header span{
        font-size: 12px;
        color: #b4bbc0;
        padding: 3px 8px;
        border: 1px solid #b4bbc0;
        border-radius: 20px;
    }

    .message-block{
        background:#fff;
        margin-bottom:10px;
        border-radius:10px;
    }

    .message-block-body{
        padding:10px;
    }

    .message-top-text{
        font-size:12px;
        background:#ffcb01;
        color:#fff;
        padding:5px 8px;
        float: right;
    }

    .message-block-title{
        font-size:14px;
        padding:5px 0;
    }

    .message-block-info{
        font-size:12px;
        color: #848a8f;
    }

    .message-list-body{
        padding-bottom: 30px;
    }

    .message-list-body ul.message-list{
        margin:0;
    }

    .message-time{
        font-size: 10px;
        color: #dedede;
        padding: 8px 0;
    }

    .message_normal{
        background:#4caf50;
    }

    .message_important{
        background:#26a2ff;
    }

    .message_agent{
        background:#ef4f4f;
    }

    .has_read_1{
        color:#888;
    }

    .has_read_label_1.message_normal{
        background:#dedede;
    }

    .has_read_label_1.message_important{
        background:#dedede;
    }

    .has_read_label_1.message_agent{
        background:#dedede;
    }


    .self-order-button{
        background: #ffcb01;
        text-align: center;
        margin-bottom: 15px;
        padding: 10px 0;
        border-radius: 20px;
        color:#fff;

        text-decoration: none;
    }

</style>



// WEBPACK FOOTER //
// src/pages/message.vue